import React from 'react';

const ActionButton = ({
  children,
  title,
  colorClass,
  onClick,
  isDisabled,
}: {
  children: React.ReactNode;
  title?: string;
  colorClass: string;
  onClick: () => void;
  isDisabled?: boolean;
}) => {
  return (
    <button
      title={title}
      onClick={onClick}
      className='block text-sm hover:bg-base-light-gray w-full min-w-[150px] px-4 py-2 active:scale-95 disabled:opacity-60 disabled:bg-gray-200 disabled:cursor-not-allowed disabled:active:scale-100 duration-300 text-nowrap'
      disabled={isDisabled}
    >
      <div
        className={`flex items-center justify-center gap-2 capitalize ${colorClass}`}
      >
        {children}
      </div>
    </button>
  );
};

export default ActionButton;
